var Queensland = "Queensland";
var Tasmania = "Tasmanien";
var Victoria = "Victoria";
var AUStates = {
	"Australian Capital Territory": "Australian Capital Territory",
	"New South Wales": "New South Wales",
	"Northern Territory": "Northern Territory",
	Queensland: Queensland,
	"South Australia": "South Australia",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "Western Australia"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
